import {ProtectedScoreResult360, ProtectedGuanyuanReport} from '../views/SensitiveReportAccess'
import {SCORE_RESULT_360_PATH, GUANYUAN_REPORT_PATH, SCORE_RESULT_PATH} from './reportPaths'

import {
    Dashboard,
    NotFound,
    Login,
    List,
    SysRole,
    SysUser,
    SysResource,
    SysWenshuTopic,
    OAuthClients,
    Password,
    ControlSystem,
    PortalSystem,
    Notifications,
    NotificationsResult,NotificationsEmpty,NotificationsSurveyForm,
    MyField,
    GuanyuanBi,
    CalendarPage,
    ErpSystem,SetNotification,SetReply,SetNotificationDetail,
    GuanyuanForm,
    LcPageSystem,
    ssoSystem,SurveyRender,OADashboard,SurveyList,FormPlayground,Class360,
    Subordinate,SubordinateKpiDetail,MyKpiDetail,SubordinatePerformanceDetail,MyPerformanceDetail,
    ScoreList,ScoreByList,SubordinateScore,MessageSys,EmployeeSys,SetScore,ScoreResult,
    KettlePassword,SetNoticeList,Log,DataRight,DataRightDetail,RegularLetter,SysUserManagement,FreshJourneyKpiMaking,
    ApiKeyManagement,ApiKeyAuditLog,Profile,CommonSql,
    McpService,McpApiRegistry,McpApiModule,McpTool,
    VibePageAccess,VibeOwnerAccess,VibeAppManagement,VibeDbAuthManagement,CodexTaskManagement,AppBuilderManagement,A2aManagement,AicDashboard,
    FrequencyMonitor
} from '../views'
export const mainRouter = [

];
export const portalRouter = [{
    pathname: '/portal/aic-dashboard/datasets/:projectId',
    component: AicDashboard,
    meta:{ title:'AIC 数据源详情', portalName:'AICDashboard' },
    exact:true
},{
    pathname: '/portal/aic-dashboard/assets',
    component: AicDashboard,
    meta:{ title:'AIC 运行资产', portalName:'AICDashboard' },
    exact:true
},{
    pathname: '/portal/aic-dashboard/overview',
    component: AicDashboard,
    meta:{ title:'AIC 总览', portalName:'AICDashboard' },
    exact:true
},{
    pathname: '/portal/aic-dashboard/datasets',
    component: AicDashboard,
    meta:{ title:'AIC 数据源', portalName:'AICDashboard' },
    exact:true
},{
    pathname: '/portal/aic-dashboard/exceptions',
    component: AicDashboard,
    meta:{ title:'AIC 异常中心', portalName:'AICDashboard' },
    exact:true
},{
    pathname: '/portal/aic-dashboard/settings',
    component: AicDashboard,
    meta:{ title:'AIC 可靠性规则', portalName:'AICDashboard' },
    exact:true
},{
    pathname: '/portal/aic-dashboard',
    component: AicDashboard,
    meta:{ title:'AIC 数据看板', portalName:'AICDashboard' },
    exact:true
},{
    pathname: '/portal/dashboard',
    component: PortalSystem,
    meta:{
        title:'portal',
        portalName:'Portal'
    },
},{
    pathname: '/portal/vibe-access/denied',
    component: VibeOwnerAccess,
    exact: true,
    meta:{
        title:'页面访问提示',
        portalName:'VibeAccessDenied'
    }
},{
    pathname: '/portal/vibe-access',
    component: VibeOwnerAccess,
    exact: true,
    meta:{
        title:'应用权限设置',
        portalName:'VibeAccess'
    }
},{
    pathname: '/portal/password',
    component: Password,
    meta:{
        title:'密码设置',
        portalName:'Password'
    },
},{
    pathname: '/portal/notifications',
    name:'Notification',
    state:{
        title:'消息中心',
        portalName:'Notification'
    },
    component: Notifications
},{
    pathname: '/portal/calendar',
    name:'Calendar',
    state:{
        title:'日历',
        portalName:'Calendar'
    },
    component: CalendarPage
},{
    pathname: '/portal/guanyuanbi',
    component: GuanyuanBi,
    meta:{
        title:'观远',
        portalName:'Portal'
    },
    exact:true
},{
    pathname: '/portal/guanyuanbi/:pageId',
    component: GuanyuanBi,
    meta:{
        title:'观远',
        portalName:'Portal'
    },
    exact:true
},{
    pathname: '/portal/erp',
    component: ErpSystem,
    meta:{
        title:'ERP',
        portalName:'Portal'
    },
},
{
    pathname: GUANYUAN_REPORT_PATH,
    component: ProtectedGuanyuanReport,
    exact: true
},
{
    pathname: '/portal/guanyuanform',
    component: GuanyuanForm
},{
    pathname: '/portal/lcpagesystem',
    component: LcPageSystem
},{
    pathname: '/portal/profile',
    component: Profile,
    meta:{
        title:'个人中心',
        portalName:'Profile'
    }
},];

export const adminRouter = [{
    pathname: '/admin/dashboard',
    component: Dashboard,
    title:'仪表盘',
    isNav:true
},{
    pathname: '/admin/list',
    component: List,
    title:'列表',
    isNav:true
},{
    pathname: '/admin/sysuserold',
    component: SysUser,
    title:'用户管理',
    isNav:true
},{
    pathname: '/admin/sysuser',
    component: SysUserManagement,
    title:'用户管理',
    isNav:true,
    exact:true
},{
    pathname: '/admin/sysuser/:id',
    component: SysUserManagement,
    title:'用户管理',
    isNav:true,
    exact:true
},{
    pathname: '/admin/sysresource',
    component: SysResource,
    title:'资源管理',
    isNav:true
},{
    pathname: '/admin/sysrole',
    component: SysRole,
    title:'角色管理',
    isNav:true
},{
    pathname: '/admin/syswenshutopic',
    component: SysWenshuTopic,
    title:'问数主题管理',
    isNav:true
},{
    pathname: '/admin/clients',
    component: OAuthClients,
    title:'OAuth客户端管理',
    isNav:true
},{
    pathname: '/admin/password',
    component: Password,
    title:'密码管理',
    isNav:true
},{
    pathname: '/admin/controlsystem',
    component: ControlSystem,
    title:'测试认证',
    isNav:true
},{
    pathname: '/admin/setnotification',
    component: SetNotification,
    title:'配置消息',
    isNav:true,
    exact:true
},{
    pathname: '/admin/setnotification/:id',
    component: SetNotification,
    title:'配置消息',
    isNav:true,
    exact:true
},{
    pathname: '/admin/setnotification/detail/:pid/:id',
    component: SetNotificationDetail,
    title:'配置消息详情',
    isNav:true,
    exact:true
},{
    pathname: '/admin/setreply',
    component: SetReply,
    title:'反馈处理',
    isNav:true
},{
    pathname: '/admin/setnoticelist',
    component: SetNoticeList,
    title:'公告设置',
    isNav:true
},{
    pathname: '/admin/log',
    component: Log,
    title:'日志查询',
    isNav:true
},{
    pathname: '/admin/dataRight',
    component: DataRight,
    title:'业务数据管理',
    isNav:true,
    exact:true
},{
    pathname: '/admin/dataRight/:id',
    component: DataRightDetail,
    title:'业务数据管理详情',
    isNav:true,
    exact:true
},{
    pathname: '/admin/ssosystem',
    component: ssoSystem,
    title:'sso配置',
    isNav:true
},{
    pathname: '/admin/apikey',
    component: ApiKeyManagement,
    title:'API Key管理',
    isNav:true
},{
    pathname: '/admin/apikeylog',
    component: ApiKeyAuditLog,
    title:'API调用日志',
    isNav:true
},{
    pathname: '/admin/commonSql',
    component: CommonSql,
    title:'常用SQL',
    isNav:true
},{
    pathname: '/admin/mcptool',
    component: McpTool,
    title:'MCP工具管理',
    isNav:true
},{
    pathname: '/admin/mcpapi',
    component: McpApiRegistry,
    title:'接口管理',
    isNav:true
},{
    pathname: '/admin/mcpModule',
    component: McpApiModule,
    title:'功能模块',
    isNav:true
},{
    pathname: '/admin/mcpservice',
    component: McpService,
    title:'MCP服务管理',
    isNav:false
},{
    pathname: '/admin/vibePageAccess',
    component: VibePageAccess,
    title:'Vibe页面权限',
    isNav:true
},{
    pathname: '/admin/frequencyMonitor',
    component: FrequencyMonitor,
    title:'接口频率监测',
    isNav:true
},{
    pathname: '/admin/vibeApps',
    component: VibeAppManagement,
    title:'Vibe应用管理',
    isNav:true
},{
    pathname: '/admin/vibeDbAuth',
    component: VibeDbAuthManagement,
    title:'Vibe授权管理',
    isNav:true
},{
    pathname: '/admin/codexTask',
    component: CodexTaskManagement,
    title:'Codex任务下发',
    isNav:true
},{
    pathname: '/admin/appBuilder',
    component: AppBuilderManagement,
    title:'应用构建',
    isNav:true
},{
    pathname: '/admin/a2aManagement',
    component: A2aManagement,
    title:'A2A管理',
    isNav:true
}];
export const oaRouter = [
    {
        pathname: '/oa/dashboard',
        component: OADashboard,
        title:'OA首页',
    },{
        pathname: '/oa/surveylist',
        component: SurveyList,
        title:'SurveyList',
        exact:true
    },{
        pathname: '/oa/surveylist/:id',
        component: SurveyList,
        title:'SurveyList',
        exact:true
    },{
        pathname: '/oa/surveylist/:pid/:id',
        component: SurveyRender,
        title:'SurveyRender',
        exact:true
    },{
        pathname: '/oa/class360',
        component: Class360,
        title:'360管理',
    },
    {
        pathname: SCORE_RESULT_360_PATH,
        component: ProtectedScoreResult360,
        title:'360打分汇总',
        exact: true,
    },
    {
        pathname: '/oa/scorelist',
        component: ScoreList,
        title:'评分列表',
    },{
        pathname: '/oa/scorebylist',
        component: ScoreByList,
        title:'被评分列表',
    },{
        pathname: '/oa/subordinate',
        component: Subordinate,
        title:'我的下级',
        exact:true
    },{
        pathname: '/oa/subordinatescore',
        component: SubordinateScore,
        title:'下级评分',
        exact:true
    },{
        pathname: '/oa/subordinate/kpidetail/:id',
        component: SubordinateKpiDetail,
        title:'下级Kpi详情',
    },{
        pathname: '/oa/mykpidetail',
        component: MyKpiDetail,
        title:'我的KPI',
    },{
        pathname: '/oa/subordinate/performancedetail/:id',
        component: SubordinatePerformanceDetail,
        title:'下级绩效详情',
    },{
        pathname: '/oa/myperformance',
        component: MyPerformanceDetail,
        title:'我的绩效',
    },{
        pathname: '/oa/messagesys',
        component: MessageSys,
        title:'消息配置',
    },{
        pathname: '/oa/employeesys',
        component: EmployeeSys,
        title:'员工管理',
    },{
        pathname: '/oa/setscore',
        component: SetScore,
        title:'评分配置',
    },
    {
        pathname: SCORE_RESULT_PATH,
        component: ScoreResult,
        title:'评分汇总',
    },
    {
        pathname: '/oa/freshjourneymaking',
        component: FreshJourneyKpiMaking,
        title:'新人之旅KPI制定方式',
    }
]
export const noPortalSide = [
    {
        pathname: '/portal/notificationresult/:id',
        component: NotificationsResult,
        title:'消息详情',
    },{
        pathname: '/portal/notificationsempty',
        component: NotificationsEmpty,
        title:'消息详情',
    },{
        pathname: '/portal/notificationsurveyform/:id',
        component: NotificationsSurveyForm,
        title:'问卷调查',
    },{
        pathname: '/portal/myfield',
        component: MyField,
        title:'消息详情',
    },{
        pathname: '/portal/kettle/password',
        component: KettlePassword,
        title:'设置密码',
    },{
        pathname: '/oa/formplayground/:id',
        component: FormPlayground,
        title:'FormPlayground',
    },{
        pathname: '/oa/regularletter',
        component: RegularLetter,
        title:'RegularLetter',
    },{
        pathname: '/404',
        component: NotFound
    },
]
